<script>
  import { onMount, getContext } from 'svelte';

  import Notification from '@utils/notification';
  import Text from '@components/Text.svelte';
  import { getGroupStore } from '@stores/group';
  let sectionsStore = getGroupStore('sectionsStore');
  let groupStore = getGroupStore('groupStore');
  let recsStore = getGroupStore('recsStore');
  import SectionAjax from '@ajax/section';

  export let sectionId;
  export let selectedSectionId;
  export let goToSection;
  let allGroupRecsLoadedStore = getContext('allGroupRecsLoadedStore');
  let group = groupStore;
  let section = sectionsStore.find(sectionId);
  let recs = recsStore;

  onMount(() => {
    let unsubSection = section.subscribe((x) => (section = x));
    let unsubRecs = recs.subscribe((x) => (recs = x));

    return () => {
      unsubSection();
      unsubRecs();
    };
  });
</script>

<style style="text/scss" lang="scss">
  .section-selected {
    background: #a893f9 !important;
    box-shadow: none !important;
    color: white !important;

    .wc-count {
      color: white !important;
      opacity: 1 !important;
      font-weight: 500 !important;
    }

    :global(.editable-content) {
      &:hover,
      &:focus {
        background: #896bd9 !important;
        color: white !important;
      }
    }
  }

  .grid-section-category {
    user-select: none;
    transition: 0s all;
    flex-shrink: 0;
    background: #fff;
    cursor: pointer;
    box-shadow: 0 22px 100px rgba(0, 0, 0, 0.09);
    height: 84px;
    width: 188px;
    border-radius: 15px;
    padding: 15px;
    padding-left: 20px;
    padding-right: 20px;
    margin: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:hover {
      box-shadow: 0 1.375rem 3rem rgba(0, 0, 0, 0.09);
    }
  }

  .wc-count {
    text-align: right;
    width: 100%;
    opacity: 0.5;
    color: black;
    display: block;
    font-size: 13px;
    line-height: 14px;
  }

  .show-more-btn {
    background: transparent;
    border-radius: 9px;
    margin-left: 15px;
    border: 2px solid #ececec;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 90px;
    position: absolute;
    top: 15px;
    right: 0;

    .wc-icon {
      transform: rotate(0);
      width: 9px;
      display: flex;
      justify-content: center;
      align-content: center;
    }
  }

  .up-arrow {
    transform: rotate(180deg);
  }
</style>

<div
  class="grid-section-category section-bar-single-section"
  class:section-selected={selectedSectionId == sectionId}
  on:click|preventDefault|stopPropagation={() => goToSection(section)}>
  <div class="wc-count">
    {#if $allGroupRecsLoadedStore}
      {[...new Set(recs.where({ section_id: section.id }).map((x) => x.rec_object_id))].length}
    {/if}
  </div>
  <span style="user-select: none; display: flex; margin-bottom: -4px;">
    <Text
      on:blur={async (e) => {
        try {
          let resp = await SectionAjax.update(group, section, {
            name: e.detail.text,
          });
          section.set({ ...section, ...resp });
        } catch (err) {
          if (err && err.full_errors && err.full_errors.length > 0) {
            Notification.send({
              text: err.full_errors[0],
              type: 'error',
            });
            section = section;
          }
        }
      }}
      on:click={() => goToSection(section)}
      text={section.name}
      expand={false}
      editable={group.permissions.edit}
      style="line-height: 20px; font-size: 14px; font-weight: 500; padding: 2px;
      padding-left: 6px; padding-right: 6px; margin: -2px; margin-left: -6px;
      margin-right: -6px; outline: none; width: inherit; max-height: 48px;"
      lines={2} />
  </span>
</div>
